import { useEffect, useRef, useState } from "react";

export function useScrollReveal({
  threshold = 0.12,
  rootMargin = "0px 0px -8% 0px",
  once = true,
} = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold, rootMargin },
    );

    observer.observe(node);

    const initialEntries = observer.takeRecords();
    if (initialEntries.some((entry) => entry.isIntersecting)) {
      setInView(true);
      if (once) observer.disconnect();
    }

    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return { ref, inView };
}
